import { HOLIDAY_FETCHING, HOLIDAY_FAILED, HOLIDAY_SUCCESS } from "./types";

import HolidayService from "../services/holiday.service";

export const allHoliday = (id, year) => async (dispatch) => {
  try {
    dispatch({
      type: HOLIDAY_FETCHING,
    });
    const res = await HolidayService.allHoliday(id, year);
    if (res) {
      dispatch({
        type: HOLIDAY_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    dispatch({
      type: HOLIDAY_FAILED,
    });
    return err;
  }
};

export const getHoliday = (id, filter) => async (dispatch) => {
  try {
    dispatch({
      type: HOLIDAY_FETCHING,
    });
    const res = await HolidayService.getHoliday(id, filter);
    if (res) {
      dispatch({
        type: HOLIDAY_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    dispatch({
      type: HOLIDAY_FAILED,
    });
    return err;
  }
};

export const postHoliday = (formData) => async () => {
  try {
    const res = await HolidayService.postHoliday(formData);
    if (res) {
      return res;
    }
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.name) ||
      error.name ||
      error.toString();
    return "Error";
  }
};

export const allHolidayByIdVendor = (id, year) => async (dispatch) => {
  try {
    dispatch({
      type: HOLIDAY_FETCHING,
    });
    const res = await HolidayService.allHolidayByIdVendor(id, year);
    if (res) {
      dispatch({
        type: HOLIDAY_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    dispatch({
      type: HOLIDAY_FAILED,
    });
    return err;
  }
};

export const getHolidayByIdVendor = (id, filter) => async (dispatch) => {
  try {
    dispatch({
      type: HOLIDAY_FETCHING,
    });
    const res = await HolidayService.getHolidayByIdVendor(id, filter);
    if (res) {
      dispatch({
        type: HOLIDAY_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    dispatch({
      type: HOLIDAY_FAILED,
    });
    return err;
  }
};

export const putHoliday = (id, formData) => async () => {
  try {
    const res = await HolidayService.putHoliday(id, formData);
    if (res) {
      return res;
    }
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.name) ||
      error.name ||
      error.toString();
    return "Error";
  }
};

export const deleteHoliday = (id, formData) => async () => {
  try {
    const res = await HolidayService.deleteHoliday(id, formData);
    if (res) {
      return res;
    }
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.name) ||
      error.name ||
      error.toString();
    return "Error";
  }
};

export const uploadFileHoliday = (formData) => async () => {
  try {
    const res = await HolidayService.uploadFileHoliday(formData);
    if (res) {
      return res;
    }
  } catch (error) {
    return error.response;
  }
};

export const getAllHolidayAndAllHolidayPattern = (year, idCompany) => async (dispatch) => {
  try {
    dispatch({
      type: HOLIDAY_FETCHING,
    });
    const res = await HolidayService.getAllHolidayAndAllHolidayPattern(year, idCompany);
    if (res) {
      dispatch({
        type: HOLIDAY_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    dispatch({
      type: HOLIDAY_FAILED,
    });
    return err;
  }
};
